import { useEffect, useState } from 'react';
import { SFAuth } from './SFAuth';

interface User {
  email?: string;
  name?: string;
  picture?: string;
  sub?: string;
}

export const useAuth = () => {
  const [user, setUser] = useState<User | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadUser = async () => {
      try {
        const auth = SFAuth.getInstance();
        const isAuth = await auth.isAuthenticated();
        
        if (isAuth) {
          const profile = auth.getUserInfo();
          setUser(profile);
        }
      } catch (error) {
        console.error('Error loading user:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadUser();
  }, []);

  const logout = async () => {
    try {
      const auth = SFAuth.getInstance();
      await auth.logout();
      setUser(null);
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  return {
    user,
    isLoading,
    logout,
    isAuthenticated: !!user,
  };
};